export default __webpack_public_path__ + "static/media/Zagg ISoD.a6695682.svg";